import { generateCardsUrl } from 'src/utils/cardsUrlGenerator';
import { DynamicObject } from 'src/utils/commonTypes';
import { ZEE5_BASE_ADDRESS as ZEE5_BASE_ADDRESS } from 'src/utils/constants/ApiConstants';
import { ASSET_SUBTYPE } from 'src/utils/constants/AppConstants';
import {
  gadar2MovieID,
  ghoomerMovieId,
  kadakSinghMovieId,
  tejasMovieId,
  samBahadurMovieId,
  Khichdi2MovieId,
  theKeralaStoryMovieId,
  mainAtalHoonMovieId
} from 'src/utils/constants/CanonicalURLConstants';
import {
  CountryCode,
  DisplayLanguage
} from 'src/utils/constants/stringConstants';
import {
  hanuManMovieId,
  AgeRatings,
  BASE_URL,
  CONSUMPTION_PAGE_STRING_CONSTANTS,
  SCHEMA_ANDROID_PLATFORM,
  SCHEMA_ANDROID_PLAY_STORE,
  SCHEMA_ANDROID_TV_PLATFORM,
  SCHEMA_DESKTOP_WEB_PLATFORM,
  SCHEMA_EMAIL,
  SCHEMA_EVENT,
  SCHEMA_FACEBOOK_URL,
  SCHEMA_GOOGLE_PLUS,
  SCHEMA_GOOGLE_VIDEO_CAST,
  SCHEMA_IMAGE,
  SCHEMA_IOS_PLATFORM,
  SCHEMA_IOS_PLAY_STORE,
  SCHEMA_MOBILE_WEB_PLATFORM,
  SCHEMA_NAME,
  SCHEMA_ORGANIZATION_TYPE,
  SCHEMA_SITE_URL,
  SCHEMA_TELEPHONE,
  SCHEMA_TWITTER_URL,
  SCHEMA_VIDEO_OBJECT_TYPE,
  SCHEMA_WEBPAGE_TYPE
} from 'src/utils/constants/utilConstants';
import { getImageURL } from 'src/utils/ImageHelper/ImageURLGenerator';

import {
  writerPadmabushanFAQschema,
  wantedFAQschema,
  SirfEkBandaaKaafiHaiFAQschema,
  rrrFAQschema,
  KisiKaBhaiKisikiJaanFAQschema,
  VenkateshDaggubattiFAQschema,
  FAQSchemaType,
  Gadar2FAQschema,
  GhoomerFAQschema,
  KadakSinghFAQschema,
  tejasMovieFAQschema,
  samBahadurMovieFAQschema,
  Khichdi2MovieFAQschema,
  theKeralaStoryFAQschema,
  mainAtalHoonFAQschema,
  hanuManMovieFAQschema
} from './FAQSchema';
import { getFirstMatchingTag, thumbnailImgUrl } from './ImageMappingHandler';
import {
  BreadCrumDataType,
  SchemaDataManipulationRequestObject
} from './SEOMetaTypes';
import { getConsumptionMetaDataObj } from './SEOMetaUtils';
import { AssetDetails } from '../../services/responseTypes/singlePlayResponse';
import {
  WRITER_PADMABUSHAN_CONTENT_ID,
  WANTED_CONTENT_ID,
  SIRF_EK_BANDAA_KAAFI_HAI_CONTENT_ID,
  RRR_CONTENT_ID,
  KISI_KA_BHAI_KISI_KI_JAAN_CONTENT_ID
} from '../../utils/constants/SEOMetaConstants';
import { getActorInfo } from '../../utils/getFormattedData';

export const getPage = (pathname: string) => {
  let pageName = '';

  if (pathname) {
    const pathUrl = pathname;
    const pathArray = pathname.split('/');
    if (
      (pathUrl.includes(`${process.env.NEXT_PUBLIC_TVSHOWSCONSUMPTION}/`) ||
        pathUrl.includes(`${process.env.NEXT_PUBLIC_KIDSCONSUMPTION}/`)) &&
      pathArray.length === 5 &&
      pathArray[pathArray.length - 1] !== 'episodes'
    ) {
      pageName = 'showDetailPage';
    } else if (
      (pathUrl.includes(`${process.env.NEXT_PUBLIC_TVSHOWSCONSUMPTION}/`) ||
        pathUrl.includes(`${process.env.NEXT_PUBLIC_KIDSCONSUMPTION}/`)) &&
      pathArray.length === 7 &&
      pathArray[pathArray.length - 1] !== 'episodes'
    ) {
      pageName = 'showEpisodePage';
    } else if (
      pathUrl.includes(`${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}/`) &&
      pathArray.length === 5 &&
      pathArray[pathArray.length - 1] !== 'episodes'
    ) {
      pageName = 'zee5originalsDetailPage';
    } else if (
      pathUrl.includes(`${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}/`) &&
      pathArray.length === 7 &&
      pathArray[pathArray.length - 1] !== 'episodes'
    ) {
      pageName = 'zee5originalEpisodePage';
    } else if (
      pathUrl.match(
        /\/movies\/(free|premium|bollywood|hollywood|south|zee5-originals|zee5-exclusive|genre\/|lang\/|celeb\/)/g
      ) &&
      pathArray.length < 5
    ) {
      pageName = 'movieSubLandingPage';
    } else if (pathUrl.includes('movies/year') && pathArray.length === 3) {
      pageName = 'yearLandingPage';
    } else if (
      pathUrl.includes('movies/') ||
      pathUrl.includes('kids/kids-movies/')
    ) {
      pageName = 'movieDetailPage';
    } else if (pathUrl.includes('news/')) {
      pageName = 'newsDetailPage';
    } else if (
      pathUrl.includes('/videos/') ||
      pathUrl.includes('kids/kids-videos/')
    ) {
      pageName = 'videoDetailPage';
    } else if (pathUrl.includes('music-videos/')) {
      pageName = 'musicDetailPage';
    } else if (pathUrl.includes(`${process.env.NEXT_PUBLIC_LIVETV}/`)) {
      pageName = 'channelDetailPage';
    } else if (pathUrl.includes(`/${process.env.NEXT_PUBLIC_LIVETV}`)) {
      pageName = 'liveTv';
    } else if (pathUrl.includes('/collections')) {
      pageName = 'viewAllPage';
    } else if (pathUrl.includes('/movies/all')) {
      pageName = 'movieAllPage';
    } else if (pathUrl.includes(`/${process.env.NEXT_PUBLIC_TVSHOWS}/all`)) {
      pageName = 'showsAllPage';
    } else if (
      pathUrl.includes(`/${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}/all`)
    ) {
      pageName = 'zee5originalsAllPage';
    } else if (
      pathUrl.includes('/videos') &&
      !pathUrl.includes(`/${process.env.NEXT_PUBLIC_VIDEOSCONSUMPTION}/`)
    ) {
      pageName = 'videoPage';
    } else if (
      (pathUrl.includes(`${process.env.NEXT_PUBLIC_TVSHOWS}/`) ||
        pathUrl.includes('kids/kids-shows/')) &&
      pathArray.length >= 6 &&
      pathArray[pathArray.length - 1] === 'episodes'
    ) {
      pageName = 'showSeasonPage';
    } else if (
      pathUrl.includes(`${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}/`) &&
      pathArray.length === 6 &&
      pathArray[pathArray.length - 1] === 'episodes'
    ) {
      pageName = 'zee5originalsSeasonPage';
    } else if (pathUrl.includes('/upcoming')) {
      pageName = 'movieDetailPage';
    } else if (
      (pathUrl.includes(`${process.env.NEXT_PUBLIC_TVSHOWS}/`) ||
        pathUrl.includes('kids/kids-tv-show/')) &&
      pathArray.length === 7 &&
      pathArray[pathArray.length - 1] === 'episodes'
    ) {
      pageName = 'showSeasonPage';
    } else if (
      pathUrl.includes(`${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}/`) &&
      pathArray.length === 7 &&
      pathArray[pathArray.length - 1] === 'episodes'
    ) {
      pageName = 'zee5originalsSeasonPage';
    } else if (pathUrl.includes('/music-videos/all')) {
      pageName = 'musicAllPage';
    } else if (
      pathUrl.includes('/channel') &&
      !pathUrl.includes('channels/details/')
    ) {
      pageName = 'channel';
    } else if (pathUrl.includes('channels/details/')) {
      pageName = 'channelDetail';
    } else if (pathUrl.includes('live-tv/news-channels')) {
      pageName = 'liveTVNewsChannel';
    } else if (pathUrl.includes('/tv-shows') && pathArray.length === 4) {
      pageName = 'tvchannelDetail';
    } else if (pathUrl.includes('/celebs')) {
      pageName = 'celebFilmography';
    }
  }
  return pageName;
};
const getUrl = (data: DynamicObject) => {
  const url = `${BASE_URL}${generateCardsUrl(data)}`;
  return url;
};

export const schemaDataManupulation = (
  requestObj: SchemaDataManipulationRequestObject
) => {
  const { type } = requestObj;
  switch (type) {
    case 'ILTSportsSchema':
      return sportsSchemeManipulation();
    case 'MatchSchema':
      return matchSchemaManiputaion(requestObj);
    case 'VideoObject':
      return createVideoSchema(requestObj);
    case 'TVSeries':
      return createTvSeriesSchema(requestObj);
    case 'TVEpisodes':
      return createTvEpisodesSchema(requestObj);
    case 'Organization':
      return createOrganizationSchema();
    case 'ChannelVideoObject':
      return createChannelVideoObject(requestObj);
    case 'websiteSearch':
      return websiteSearchSchema();
    case 'Movie':
      return createMovieSchema(requestObj);
    case 'itemList':
      return itemListSchema(requestObj);
    case 'faqList':
      return faqListSchema(requestObj);
    case 'ItemListCollection':
      return itemListCollectionSchema(requestObj);
    case 'webPageSchema':
      return createWebPageSchema(requestObj);
    case 'siteNavigationElement':
      return siteNavigationElementSchema(requestObj);
    case 'Clip':
      return createClipSchema(requestObj);
    case 'MediaObject':
      return createMediaSchema(requestObj);
    case 'Table':
      return tableSchema(requestObj);
    case 'QnA':
      return QnASchema(requestObj);
  }
  return false;
};

/**
 * Get current offset
 */
const getOffset = () => {
  const offset = new Date().getTimezoneOffset();
  const o = Math.abs(offset);
  const timeOffset = `${
    (offset < 0 ? '+' : '-') + `00${Math.floor(o / 60)}`.slice(-2)
  }:${`00${o % 60}`.slice(-2)}`;
  return timeOffset;
};

/**
 * Get current date
 */
const getStartEndDate = () => {
  const offset = getOffset();
  const date = new Date();
  const month = date.getMonth() + 1;
  const formatMonth = month > 9 ? month : `0${month}`;
  const day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
  const hour = date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`;
  const minute =
    date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;
  const sec =
    date.getSeconds() > 9 ? date.getSeconds() : `0${date.getSeconds()}`;

  const dateStringPrevYear = `${
    date.getFullYear() - 1
  }-${formatMonth}-${day}T${hour}:${minute}:${sec}${offset}`;
  const dateStringNextYear = `${
    date.getFullYear() + 1
  }-${formatMonth}-${day}T${hour}:${minute}:${sec}${offset}`;
  const arrayData = [dateStringPrevYear, dateStringNextYear];
  return arrayData;
};

/**
 * Channel Video Object Schema
 */
function createChannelVideoObject(requestObj: DynamicObject) {
  const { apiData, url, location } = requestObj;
  let startDate = '';
  let contentUrl = '';
  // let endDate = "";

  startDate = startDateHandler(url, startDate);
  contentUrl = contestUrlHandler(contentUrl, location, apiData);

  const schemaObj = {
    '@context': SCHEMA_SITE_URL,
    '@type': SCHEMA_VIDEO_OBJECT_TYPE,
    contentURL: contentUrl || '',
    // "@id": url,
    // "@id": `${url}#zee5`,
    name: apiData.title ? apiData.title : '',
    /* regular expresion for removing line breaks */
    description: apiData.description
      ? apiData.description.replace(/\n|\r/g, '')
      : '',
    thumbnailUrl: thumbnailImgUrl(getPage(location), apiData),
    inLanguage:
      apiData && apiData.languages && apiData.languages[0]
        ? apiData.languages[0]
        : '',
    regionsAllowed: [
      {
        '@type': getPage(location) === 'tvchannelDetail' ? 'Country' : 'Place',
        name: 'IN'
      }
    ],
    embedUrl: url,
    uploadDate: startDate,
    publication: {
      '@type': 'BroadcastEvent',
      isLiveBroadcast: true,
      startDate
      // endDate
    }
  };
  return JSON.stringify(schemaObj);
}

const contestUrlHandler = (
  contentUrl: string,
  location: string,
  apiData: DynamicObject
) => {
  if (
    getPage(location) === 'channelDetailPage' ||
    getPage(location) === 'tvchannelDetail'
  ) {
    contentUrl = apiData?.extended?.url_name
      ? apiData.extended.url_name
      : apiData.stream_url;
  } else {
    contentUrl = apiData.stream_url;
  }
  return contentUrl;
};
const startDateHandler = (url: string, startDate: string) => {
  if (
    url ===
    `https://www.zee5.com/${process.env.NEXT_PUBLIC_CHANNELCONSUMPTION}/sunburn-festival-2019-sunburn-festival/0-9-213`
  ) {
    startDate = `2019-12-23T00:00:00+05:30`;
    // endDate = `2019-12-31T00:00:00+05:30`;
  } else {
    const getdata = getStartEndDate();
    startDate = getdata[0];
    // endDate = getdata[ 1 ];
  }
  return startDate;
};

/**
 * Get Image url
 */
const getImageUrl = (data: DynamicObject) => {
  let imageUrl = '';
  const tagName = getFirstMatchingTag(data.tags);
  if (tagName) {
    imageUrl = getImageURL({
      tagName,
      item: data as AssetDetails,
      deviceWidth: 600
    });
  }
  return imageUrl;
};

/**
 * Get rail object Data
 */
const getRailData = (railData: DynamicObject[]) => {
  let railObjData: DynamicObject[] = [];
  if (railData && railData.length > 0) {
    railObjData = [...railData];
    let length = 10;
    if (railObjData.length < 10) {
      length = railData.length;
    }
    railObjData = railObjData.splice(0, length);
    railObjData.map((row: DynamicObject) => {
      const url = getUrl(row);
      const thumbnailUrl = getImageUrl(row);
      row.url = url;
      row.thumbnailUrl = thumbnailUrl;
      return row;
    });
  }
  return railObjData;
};

/**
 * Get Actor object
 */
//TODO: ADD DataTypes
const getActorEpisode = (actors: string[], type?: string) => {
  let actorEpisode: DynamicObject[] = [];
  if (actors && actors.length > 0) {
    let obj: DynamicObject = {};
    actors.map((item: string) => {
      if (type === 'tvSeries') {
        const itemValue = item.split(':');
        obj = {
          '@type': 'Person',
          name: itemValue && itemValue[0] ? itemValue[0] : ''
        };
      } else {
        obj = {
          '@type': 'Person',
          name: item && item[0]
        };
      }
      actorEpisode = [...actorEpisode, obj];
      return item;
    });
  }
  return actorEpisode;
};

/**
 * Get Actor String
 */
const getActorString = (actors: string[]) => {
  let actorString = '';
  if (actors && actors.length > 0) {
    actors.map((item: string, i: number) => {
      actorString += item && item[0] ? item[0] : '';
      if (i < actors.length - 1) {
        actorString += ',';
      }
      return item;
    });
  }
  return actorString;
};

// get action platform
const getActionPlatForm = () => {
  return [
    SCHEMA_DESKTOP_WEB_PLATFORM,
    SCHEMA_MOBILE_WEB_PLATFORM,
    SCHEMA_IOS_PLATFORM,
    SCHEMA_ANDROID_PLATFORM,
    SCHEMA_ANDROID_TV_PLATFORM,
    SCHEMA_GOOGLE_VIDEO_CAST
  ];
};

const getHour = (duration: number) => Math.floor(duration / 3600);
const getMinutes = (duration: number) => Math.floor((duration % 3600) / 60);
const getSeconds = (duration: number) => duration % 60;

const getDuration = (duration: number): string => {
  return duration >= 0
    ? `PT${getHour(duration)}H${getMinutes(duration)}M${getSeconds(duration)}S`
    : getDuration(0);
};

const getCountryLanguage = (displayLanguage: string, countryCode: string) =>
  displayLanguage === DisplayLanguage.ENGLISH && countryCode === CountryCode.IN
    ? 'en-in'
    : displayLanguage;

const getPublishedDate = (uploadDate: string) => {
  const date = new Date(uploadDate);
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
};

/**
 *  Video Object Schema
 */
const createVideoSchema = (requestObj: DynamicObject) => {
  const {
    apiData,
    showDetail,
    z5Strings,
    translation: displayLanguage,
    tag,
    url,
    countryCode,
    location
  } = requestObj;

  const metaData =
    Object.keys(apiData).length > 0
      ? getConsumptionMetaDataObj({
          item: apiData,
          z5Strings,
          translation: displayLanguage,
          tag
        })
      : {};

  const countryLanguage = getCountryLanguage(displayLanguage, countryCode);

  const {
    directors,
    actors,
    title,
    originalTitle,
    genres,
    audioLanguages,
    description
  } = metaData;

  const pageName = getPage(location);

  const {
    id: videoId = '',
    release_date: uploadDate = '',
    extended,
    stream_url: streamUrl
  } = apiData;

  const publishedDate = uploadDate ? getPublishedDate(uploadDate) : '';

  const embedUrl = videoId ? `${BASE_URL}/embed/${videoId}` : '';

  //TODO: Refactor this
  let actorInfo = [];
  if (actors && actors.length) {
    actorInfo = actors;
  } else {
    const { actors: showDetailActors = [] } = showDetail;
    actorInfo = getActorInfo(showDetailActors);
  }

  const actorString = getActorString(actorInfo);
  const actorEpisode = getActorEpisode(actors);
  const durationString = getDuration(apiData.duration);

  //NOTE: what is the extended data
  const { url_name: contentUrl = streamUrl } = extended || {};

  const schemaObj: DynamicObject = {
    '@context': SCHEMA_SITE_URL,
    '@type': SCHEMA_VIDEO_OBJECT_TYPE,
    name: [{ '@language': countryLanguage, '@value': title || originalTitle }],
    //Note: this regular expression is used only for channel consumption data why
    /* regular expresion for removing line breaks */
    description: [{ '@language': countryLanguage, '@value': description }],
    inLanguage: audioLanguages && audioLanguages[0],
    thumbnailUrl: thumbnailImgUrl(pageName, apiData),
    contentUrl: url,
    url: contentUrl,
    author: title || originalTitle,
    headline: title || originalTitle,
    genre: genres,
    embedUrl,
    uploadDate: publishedDate,
    // datePublished: publishedDate,
    publisher: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: SCHEMA_NAME,
      url: ZEE5_BASE_ADDRESS,
      image: `${ZEE5_BASE_ADDRESS}/images/ZEE5_logo.svg?ver=2.50.52`,
      logo: {
        '@type': 'ImageObject',
        url: `${ZEE5_BASE_ADDRESS}/images/ZEE5_logo.svg?ver=2.50.52`,
        width: 600,
        height: 60
      }
    }
  };

  const { asset_subtype: assetSubtype = '', asset_type: assetType = null } =
    showDetail || {};

  const isTvShowOrOriginal = /^(tvshow|original)$/.test(assetSubtype);

  //TOOO: check whether this can be reused

  if (!isTvShowOrOriginal) {
    schemaObj.datePublished = publishedDate;
  }

  if (
    parseInt(assetType) === 0 &&
    (assetSubtype === 'trailer' || assetSubtype === 'video')
  ) {
    schemaObj.image = thumbnailImgUrl(pageName, apiData);
    delete schemaObj.embedUrl;
  }

  if (!tag) {
    schemaObj.duration = durationString;
    schemaObj.director =
      directors && directors.length ? directors : showDetail.directors;
    if (
      !url.includes('/music-videos/') &&
      !url.includes(`/${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}/`)
    ) {
      schemaObj.actors =
        actorString && actorString.length ? actorString.split(',') : [];
    }
    schemaObj.actors = actorEpisode;
  } else if (tag !== 'News') {
    schemaObj.duration = durationString;
    schemaObj.director =
      directors && directors.length ? directors : showDetail.directors;
    schemaObj.actors =
      actorString && actorString.length ? actorString.split(',') : [];
  }
  return JSON.stringify(schemaObj);
};

/**
 * LicenseData
 */
const getLicenseData = (licenseData: {
  licensing_periods?: DynamicObject;
  license_from?: string;
  license_until?: string;
}) => {
  let subscriptionData: DynamicObject = {};
  let freeData: DynamicObject = {};
  let eligibleRegionFree: DynamicObject[] = [];
  let eligibleRegionSubscribe: DynamicObject[] = [];
  const OffsetValue = getOffset();
  if (
    licenseData &&
    Object.keys(licenseData).length &&
    licenseData.licensing_periods
  ) {
    Object.entries(licenseData.licensing_periods).map(([key, row]) => {
      const obj = {
        '@type': 'Country',
        name: key
      };
      if (row.business_type === 'advertisement_downloadable') {
        eligibleRegionFree = [...eligibleRegionFree, obj];
      }
      if (row.business_type === 'premium_downloadable') {
        eligibleRegionSubscribe = [...eligibleRegionSubscribe, obj];
      }

      return row;
    });
    const availabilityStarts = `${licenseData.license_from}${OffsetValue}`;
    const availabilityEnds = `${licenseData.license_until}${OffsetValue}`;
    subscriptionData = {
      '@type': 'Offer',
      availabilityStarts,
      availabilityEnds,
      category: 'subscription',
      eligibleRegion: eligibleRegionSubscribe
    };
    freeData = {
      '@type': 'Offer',
      availabilityStarts,
      availabilityEnds,
      category: 'free',
      eligibleRegion: eligibleRegionFree
    };
  }
  const dataArray = [];
  if (eligibleRegionSubscribe && eligibleRegionSubscribe.length > 0) {
    dataArray.push(subscriptionData);
  }
  if (eligibleRegionFree && eligibleRegionFree.length > 0) {
    dataArray.push(freeData);
  }
  return dataArray;
};

/**
 * Movie Object Schema
 */
function createMovieSchema(requestObj: DynamicObject) {
  const {
    apiData,
    z5Strings,
    translation,
    tag,
    ogImage,
    url,
    // trailerData,
    countryCode,
    licenseData
    // location
  } = requestObj;
  let metaData: DynamicObject = {};
  if (Object.keys(apiData).length > 0) {
    metaData = getConsumptionMetaDataObj({
      item: apiData,
      z5Strings,
      translation,
      tag
    });
  }
  const license = getLicenseData(licenseData);
  let countryLanguage = '';
  if (
    translation === DisplayLanguage.ENGLISH &&
    countryCode === CountryCode.IN
  ) {
    countryLanguage = 'en-in';
  } else {
    countryLanguage = translation;
  }
  const {
    directors,
    actors,
    title,
    originalTitle,
    genres,
    audioLanguages,
    description
  } = metaData;
  const ageRatingObj: DynamicObject = {};
  Object.keys(AgeRatings).forEach((key) => {
    ageRatingObj[AgeRatings[key as keyof typeof AgeRatings]] = key;
  });

  const uploadDate = apiData.release_date ? apiData.release_date : '';
  let dateCreated = '';
  if (uploadDate) {
    const date = new Date(uploadDate);
    dateCreated = `${date.getFullYear()}-${
      parseInt(date.getMonth().toString(), 10) + 1
    }-${date.getDate()}`;
  }
  const actorString = getActorString(actors);
  const durationString = getDuration(apiData.duration);
  const name = title || originalTitle;
  const actionPlatform = getActionPlatForm();
  const seoDescription =
    apiData && apiData.extended && apiData.extended.seo_description;
  const countries =
    apiData && apiData.countries && apiData.countries.length > 0
      ? apiData.countries[0]
      : 'IN';
  const schemaObj = {
    '@context': SCHEMA_SITE_URL,
    '@type': 'Movie',
    name: [{ '@language': countryLanguage, '@value': name }],
    /* regular expresion for removing line breaks */
    description: [{ '@language': countryLanguage, '@value': description }],
    about: [{ '@language': countryLanguage, '@value': seoDescription || '' }],

    image: ogImage,
    duration: durationString,
    dateCreated,
    director: directors,
    genre: genres,
    actors: actorString.split(','),
    countryOfOrigin: '',
    releasedEvent: {
      '@type': 'PublicationEvent',
      name,
      startDate: dateCreated,
      location: {
        '@type': 'Country',
        name: [countries]
      }
    },
    potentialAction: {
      '@type': 'WatchAction',
      target: {
        '@type': 'EntryPoint',
        inLanguage: audioLanguages && audioLanguages[0],
        urlTemplate: url,
        actionPlatform
      },
      actionAccessibilityRequirement: {
        '@type': 'ActionAccessSpecification',
        category: 'category',
        eligibleRegion: [
          {
            '@type': 'Country',
            name: 'IN'
          }
        ]
      },
      expectsAcceptanceOf: license
    }
    // trailer: {
    //   "@type": "VideoObject",
    //   name: trailerData && trailerData.title ? trailerData.title : title,
    //   description: trailerData && trailerData.description ? trailerData.description : description,
    //   thumbnailUrl: thumbnailImgUrl(getPage(location), apiData),
    //   uploadDate,
    //   embedUrl,
    //   contentUrl
    // }
  };
  return JSON.stringify(schemaObj);
}

function createClipSchema(requestObj: DynamicObject) {
  const {
    apiData,
    pageMeta,
    z5Strings,
    translation,
    tag,
    url,
    countryCode,
    location
  } = requestObj;
  let metaData: any = {};
  if (Object.keys(apiData).length > 0) {
    metaData = getConsumptionMetaDataObj({
      item: apiData,
      z5Strings,
      translation,
      tag
    });
  }
  let countryLanguage = '';
  if (translation === 'en' && countryCode === 'IN') {
    countryLanguage = 'en-in';
  } else {
    countryLanguage = translation;
  }
  const { title, originalTitle, genres, description } = metaData;
  let publishedDate = '';
  const releaseDate = apiData.release_date;
  if (releaseDate) {
    const date = new Date(releaseDate);
    publishedDate = `${date.getFullYear()}-${
      parseInt(date.getMonth().toString(), 10) + 1
    }-${date.getDate()}`;
  }
  const seoDescription = pageMeta ? pageMeta.description : '';
  const name = title || originalTitle;
  const schemaObj = {
    '@context': SCHEMA_SITE_URL,
    '@type': 'Clip',
    name: [{ '@language': countryLanguage, '@value': name }],
    description: [{ '@language': countryLanguage, '@value': seoDescription }],
    url,
    image: thumbnailImgUrl(getPage(location), apiData),
    genre: genres,
    about: [{ '@language': countryLanguage, '@value': description }],
    datePublished: publishedDate
  };
  return JSON.stringify(schemaObj);
}

function sportsSchemeManipulation() {
  const schemaObj = {
    '@context': SCHEMA_SITE_URL,
    '@type': SCHEMA_EVENT,
    name: 'ILT20 2023',
    description:
      'First edition of International League T20 cricket tournament, to be played in the United Arab Emirates',
    startDate: '2023-01-13T19:30',
    endDate: '2023-02-12',
    location: 'United Arab Emirates',
    eventStatus: 'https://schema.org/EventScheduled'
  };
  return JSON.stringify(schemaObj);
}

function matchSchemaManiputaion(requestObj: DynamicObject) {
  const schemaObj = {
    '@context': SCHEMA_SITE_URL,
    '@type': SCHEMA_EVENT,
    name: requestObj.generatedtitle,
    startDate: requestObj.data.startDate,
    location: requestObj?.data?.venue.name,
    eventStatus: 'https://schema.org/EventScheduled'
  };
  return JSON.stringify(schemaObj);
}

/* Method for TV Series Schema JSON Creation */
function createTvSeriesSchema(requestObj: DynamicObject) {
  const {
    apiData,
    z5Strings,
    translation,
    tag,
    location,
    url,
    countryCode,
    licenseData
  } = requestObj;
  let metaData: DynamicObject = {};
  if (Object.keys(apiData).length > 0) {
    metaData = getConsumptionMetaDataObj({
      item: apiData,
      z5Strings,
      translation,
      tag
    });
  }
  let countryLanguage = '';
  if (
    translation === DisplayLanguage.ENGLISH &&
    countryCode === CountryCode.IN
  ) {
    countryLanguage = 'en-in';
  } else {
    countryLanguage = translation;
  }
  const { title, originalTitle, genres, audioLanguages, description } =
    metaData;
  const license = getLicenseData(licenseData);
  const actors = apiData.actors ? apiData.actors : '';
  const director = apiData.directors ? apiData.directors : '';
  const actorEpisode = getActorEpisode(actors, 'tvSeries');
  let seasonsdata: DynamicObject[] = [];
  let datePublished = '';
  apiData &&
    apiData.seasons &&
    apiData.seasons.map((item: DynamicObject) => {
      const releaseDate = item.release_date;
      if (releaseDate) {
        const date = new Date(releaseDate);
        datePublished = `${date.getFullYear()}-${
          parseInt(date.getMonth().toString(), 10) + 1
        }-${date.getDate()}`;
      }
      const obj = {
        '@type': 'TVSeason',
        datePublished,
        name: item.title ? item.title : item.original_title,
        numberOfEpisodes: item.total_episodes ? item.total_episodes : ''
      };
      seasonsdata = [...seasonsdata, obj];
      return item;
    });
  const actionPlatform = getActionPlatForm();
  const schemaObj = {
    '@context': SCHEMA_SITE_URL,
    '@type': 'TVSeries',
    url,
    // id: `${url}#TvSeries`,
    image: thumbnailImgUrl(getPage(location), apiData),
    name: [{ '@language': countryLanguage, '@value': title || originalTitle }],
    description: [{ '@language': countryLanguage, '@value': description }],
    genre: genres,
    inLanguage: audioLanguages && audioLanguages[0],
    actors: actorEpisode,
    director,
    containsSeason: seasonsdata,
    releasedEvent: {
      '@type': 'PublicationEvent',
      name: title || originalTitle,
      startDate: datePublished
    },
    potentialAction: {
      '@type': 'WatchAction',
      target: {
        '@type': 'EntryPoint',
        inLanguage: audioLanguages && audioLanguages[0],
        urlTemplate: url,
        actionPlatform
      },
      expectsAcceptanceOf: license
    }
  };
  return JSON.stringify(schemaObj);
}
const getSeasonDetails = (seasonDetail: DynamicObject) => {
  return seasonDetail?.label ? seasonDetail[0].orderid : '';
};
const getType = (assetSubtype: string, isOriginals: boolean) => {
  let type = '';
  if (assetSubtype === ASSET_SUBTYPE.ORIGINALS || isOriginals) {
    type = CONSUMPTION_PAGE_STRING_CONSTANTS.EPISODE;
  } else {
    type = CONSUMPTION_PAGE_STRING_CONSTANTS.TVEPISODE;
  }
  return type;
};
const getShowDetailsSeasonTitle = (showDetailData: DynamicObject) => {
  let showDetailSeasonTitle = '';
  if (showDetailData?.seasons?.length) {
    showDetailSeasonTitle = showDetailData.seasons[0].title || '';
  } else if (showDetailData?.season_details?.length) {
    showDetailSeasonTitle = showDetailData.season_details[0].title || '';
  }
  return showDetailSeasonTitle;
};
const getSeasonInfo = (seasonDetail: DynamicObject) => {
  let seasonInfo = '';
  if (seasonDetail && seasonDetail.length) {
    seasonInfo = seasonDetail[0].orderid;
  }
  return seasonInfo;
};
const getSeasonDetailObject = (seasonDetail: DynamicObject) => {
  const seasonDetailObject =
    seasonDetail && typeof seasonDetail === 'string'
      ? // ? parseJsonObject(seasonDetail)
        //TODO: check TATASKY logic in parseJsonObject
        JSON.parse(seasonDetail)
      : seasonDetail;
  return seasonDetailObject;
};
function createTvEpisodesSchema(requestObj: DynamicObject) {
  const {
    apiData,
    z5Strings,
    translation,
    tag,
    location,
    url,
    countryCode,
    licenseData,
    showDetailData
  } = requestObj;
  const metaData =
    Object.keys(apiData).length > 0
      ? getConsumptionMetaDataObj({
          item: apiData,
          z5Strings,
          translation,
          tag
        })
      : {};
  const countryLanguage = getCountryLanguage(translation, countryCode);
  const license = getLicenseData(licenseData);
  const actionPlatform = getActionPlatForm();
  const { title, originalTitle, description, genres } = metaData;
  let { audio_languages: audioLanguages = '', season_details: seasonDetail } =
    apiData || {};
  const {
    release_date: releaseDate = '',
    duration,
    countries = [],
    season: { index = undefined, title: apiTitle = '' } = {},
    episode_number,
    orderid: apiDataOrderid,
    asset_subtype: assetSubtype,
    isOriginals
  } = apiData || {};

  audioLanguages = audioLanguages?.[0] || audioLanguages;
  const datePublished = getPublishedDate(releaseDate);
  const durationString = getDuration(duration);
  const country = countries.length > 0 ? countries[0] : '';
  seasonDetail = getSeasonDetailObject(seasonDetail);

  const seasonInfo = getSeasonInfo(seasonDetail);

  const seasonNumber =
    index || showDetailData?.season_details?.[0]?.orderid || seasonInfo;

  const showDetailSeasonTitle = getShowDetailsSeasonTitle(showDetailData);
  const seasonNameNumber = seasonNumber
    ? `Season ${seasonNumber}`
    : showDetailSeasonTitle;

  const seasonName =
    apiTitle ||
    `${
      showDetailData?.showDetails?.title ||
      showDetailData?.showDetails?.originalTitle ||
      showDetailData?.showDetails?.original_title ||
      showDetailData?.tvshow_name
    } ${seasonNameNumber}`;
  const type = getType(assetSubtype, isOriginals);
  const episodeNumber = episode_number || apiDataOrderid || '';
  const schemaObj: DynamicObject = {
    '@context': [
      SCHEMA_SITE_URL,
      {
        '@language': audioLanguages
      }
    ],
    '@type': type,
    url,
    // id: `${url}#Episode`,
    image: thumbnailImgUrl(getPage(location), apiData),
    name: [{ '@language': countryLanguage, '@value': title || originalTitle }],
    description: [{ '@language': countryLanguage, '@value': description }],
    genre: genres,
    inLanguage: audioLanguages,
    duration: apiData && apiData.duration > 0 ? durationString : '',
    episodeNumber: episodeNumber || '',
    releasedEvent: {
      '@type': 'PublicationEvent',
      name: title || originalTitle,
      startDate: datePublished,
      location: {
        '@type': 'Country',
        name: [country]
      }
    },
    potentialAction: {
      '@type': 'WatchAction',
      target: {
        '@type': 'EntryPoint',
        inLanguage: audioLanguages,
        urlTemplate: url,
        actionPlatform
      },
      expectsAcceptanceOf: license
    }
  };
  schemaObjHandler(
    type,
    schemaObj,
    countryLanguage,
    seasonName,
    seasonNumber,
    title,
    originalTitle,
    url
  );

  return JSON.stringify(schemaObj);
}

const schemaObjHandler = (
  type: string,
  schemaObj: DynamicObject,
  countryLanguage: string,
  seasonName: string,
  seasonNumber: number | string | object,
  title: string,
  originalTitle: string,
  url: string
) => {
  if (
    type === CONSUMPTION_PAGE_STRING_CONSTANTS.TVEPISODE ||
    type === CONSUMPTION_PAGE_STRING_CONSTANTS.EPISODE
  ) {
    schemaObj.partOfSeason = [
      {
        '@type': 'TVSeason',
        name: [{ '@language': countryLanguage, '@value': seasonName }],
        seasonNumber
      }
    ];
    schemaObj.partOfSeries = [
      {
        '@type': 'TVSeries',
        '@id': url,
        name: title || originalTitle
      }
    ];
  }
};

function websiteSearchSchema() {
  const schemaObj = {
    '@context': SCHEMA_SITE_URL,
    '@type': 'WebSite',
    url: `${BASE_URL}/`,
    name: 'Zee5',
    potentialAction: [
      {
        '@type': 'SearchAction',
        target: `${BASE_URL}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string'
      }
    ]
  };
  return JSON.stringify(schemaObj);
}

function createWebPageSchema(requestObj: DynamicObject) {
  const schemaObj = {
    '@context': SCHEMA_SITE_URL,
    '@type': SCHEMA_WEBPAGE_TYPE,
    name: requestObj.title,
    description: requestObj.description,
    speakable: {
      '@type': 'SpeakableSpecification',
      cssSelector: ['h1', "p[data-testid='content-description']"],
      url: `${requestObj.url}`
    }
  };
  return JSON.stringify(schemaObj);
}

function createOrganizationSchema() {
  const schemaObj = {
    '@context': SCHEMA_SITE_URL,
    '@type': SCHEMA_ORGANIZATION_TYPE,
    image: SCHEMA_IMAGE,
    url: BASE_URL,
    email: SCHEMA_EMAIL,
    name: SCHEMA_NAME,
    telephone: SCHEMA_TELEPHONE,
    logo: {
      '@type': 'ImageObject',
      url: `${BASE_URL}/images/ZEE5_logo.svg?ver=${process.env.APP_VERSION}`,
      width: 600,
      height: 60
    },
    sameAs: [
      SCHEMA_FACEBOOK_URL,
      SCHEMA_TWITTER_URL,
      SCHEMA_GOOGLE_PLUS,
      SCHEMA_ANDROID_PLAY_STORE,
      SCHEMA_IOS_PLAY_STORE
    ]
  };
  return JSON.stringify(schemaObj);
}

export const breadcrumbSchema = (breadcrumbs: BreadCrumDataType[]) => {
  // const breadcrumbStrings = z5Strings && z5Strings.BREADCRUMB;
  // const breadcrumbsObj = [ { label: breadcrumbStrings.HOME, url: "" }, ...breadcrumbs ];
  let itemListElement: DynamicObject[] = [];
  breadcrumbs.map((item: BreadCrumDataType, index: number) => {
    const position = parseInt(`${index}`, 10) + 1;
    if (item.label) {
      const obj = {
        '@type': 'ListItem',
        position,
        item: {
          // "@id": `${BASE_URL}${item.url}`,
          '@id': `${item.url}`,
          name: `${item.label}`
        }
      };
      itemListElement = [...itemListElement, obj];
    }
    return item;
  });

  const breadCrumbData = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement
  };
  return JSON.stringify(breadCrumbData);
};

export const personSchema = (person: DynamicObject) => {
  const schemaObj = {
    '@context': SCHEMA_SITE_URL,
    '@type': 'Person',
    '@id': `${person.url}`,
    name: `${person.name}`,
    url: `${person.url}`,
    image: `${person.image}`,
    jobTitle: `${person.jobTitle}`
  };
  return JSON.stringify(schemaObj);
};

/**
 * Table Schema
 */
function tableSchema(requestObj: DynamicObject) {
  const schemaObj = {
    '@context': SCHEMA_SITE_URL,
    '@type': 'Table',
    about: requestObj.listData
  };
  return JSON.stringify(schemaObj);
}

/**
 *
 * Get List item Title
 */
const getTitle = (
  apiData: DynamicObject,
  pageName: string,
  seasonIndex: number
) => {
  let title = '';
  let name = '';
  if (
    pageName === 'showDetailPage' ||
    pageName === 'showEpisodePage' ||
    pageName === 'zee5originalEpisodePage'
  ) {
    title = apiData && apiData.title ? apiData.title : apiData.original_title;
    if (title) {
      name = `${title} episodes`;
    }
  } else if (
    pageName === 'zee5originalsDetailPage' ||
    pageName === 'showSeasonPage' ||
    pageName === 'zee5originalsSeasonPage'
  ) {
    title = apiData && apiData.title ? apiData.title : apiData.original_title;
    let seasonNumber = '';
    if (seasonIndex >= 0) {
      seasonNumber =
        apiData &&
        apiData.seasons &&
        apiData.seasons[seasonIndex] &&
        apiData.seasons[seasonIndex].episode_number
          ? apiData.seasons[seasonIndex].episode_number
          : '';
    }
    if (title) {
      name = `${title} Season ${seasonNumber} episodes`;
    }
  } else {
    name = apiData && apiData.title ? apiData.title : apiData.original_title;
  }
  return name;
};
/**
 * Item List Schema
 */
// eslint-disable-next-line cyclomatic-complexity/zee-codeBlockComplexity
function itemListSchema(requestObj: DynamicObject) {
  const { apiData, railData, location, seasonIndex, seoData } = requestObj;
  const railObjData = getRailData(railData);
  const pageName = getPage(location);
  let name = '';
  if (pageName === 'celebFilmography') {
    name = `List of Top ${railData.name} Movies`;
  } else {
    name = getTitle(apiData, pageName, seasonIndex);
  }
  let itemListElement: DynamicObject[] = [];
  // For movie consumption page remove carousels so return ''
  // https://asiatvusa.atlassian.net/browse/PWA2-18671
  // This was enabled for TV shows and web series
  // in https://asiatvusa.atlassian.net/browse/COR-22070
  if (pageName === 'movieDetailPage') {
    return '';
  }
  if (
    pageName === 'movieDetailPage' &&
    apiData &&
    Object.keys(apiData).length > 0
  ) {
    const obj1 = {
      '@type': 'ListItem',
      position: 1,
      item: 'Total Duration'
    };
    const obj2 = {
      '@type': 'ListItem',
      position: 2,
      item: 'Audio Languages'
    };
    itemListElement = [obj1, obj2];
  }

  if (pageName === 'yearLandingPage' && apiData && apiData.length > 0) {
    apiData.map((item: DynamicObject, index: number) => {
      const position = parseInt(index.toString(), 10) + 1;
      const nameTitle = item;
      const url = `${location}/${item.title}`;

      const obj = {
        '@type': 'ListItem',
        position,
        name: nameTitle,
        image: item.thumbnailUrl,
        url
      };
      itemListElement = [...itemListElement, obj];
      return item;
    });
  }
  if (seoData?.length > 0) {
    seoData.map((item: DynamicObject, index: number) => {
      const position = parseInt(index.toString(), 10) + 1;
      const obj = {
        '@type': 'ListItem',
        position,
        name: item.title
        // item:
      };
      itemListElement = [...itemListElement, obj];
      return item;
    });
  }
  if (pageName === 'celebFilmography') {
    apiData.map((item: DynamicObject, index: number) => {
      const position = parseInt(index.toString(), 10) + 1;
      const obj = {
        '@type': 'ListItem',
        position,
        name: item.title
      };
      itemListElement = [...itemListElement, obj];
      return item;
    });
  }
  if (railObjData?.length > 0) {
    railObjData.map((item: DynamicObject, index: number) => {
      const position = parseInt(index.toString(), 10) + 1;
      let description = item.description
        ? item.description.replace(/\n|\r/g, '')
        : '';
      const itemTitle = item.title ? item.title : item.original_title;
      let url = item.url;
      let image = '';
      const objResponse = objHandler(
        pageName,
        name,
        description,
        url,
        item,
        image,
        position,
        itemTitle,
        apiData,
        location
      );
      image = objResponse.image;
      name = objResponse.name;
      description = objResponse.description;
      url = objResponse.url;

      itemListElement = [...itemListElement, objResponse.obj];
      return item;
    });
  }

  const schemaObj = {
    '@context': SCHEMA_SITE_URL,
    '@type': 'ItemList',
    name,
    itemListOrder: seoData?.length
      ? `${SCHEMA_SITE_URL}ItemListOrderDescending`
      : `${SCHEMA_SITE_URL}ItemListOrderAscending`,
    itemListElement
  };
  return JSON.stringify(schemaObj);
}

const objHandler = (
  pageName: string,
  name: string,
  description: string,
  url: string,
  item: DynamicObject,
  image: string,
  position: number,
  itemTitle: string,
  apiData: DynamicObject,
  location: string
) => {
  if (pageName === 'channelDetailPage' || pageName === 'liveTVNewsChannel') {
    name = '';
    description = '';
  }
  if (pageName === 'channelDetailPage' || pageName === 'movieSubLandingPage') {
    url = location;
  }
  if (pageName === 'movieDetailPage') {
    name = item && ` ${item.originalTitle}`;
    image = item && item.image_url;
    url = item.url;
  }
  const obj = {
    '@type': 'ListItem',
    position,
    name:
      pageName === 'channelDetailPage' || pageName === 'liveTv'
        ? item.title
        : itemTitle || name,
    image:
      item?.thumbnailUrl || image || thumbnailImgUrl(pageName, apiData)?.[0],
    url:
      pageName === 'channelDetailPage' || pageName === 'liveTv'
        ? item.slug
        : `${BASE_URL}${generateCardsUrl(item)}`,
    description
  };
  return {
    name,
    description,
    url,
    image,
    obj
  };
};

/**
 * Item List Collection Schema
 */
function itemListCollectionSchema(requestObj: DynamicObject) {
  const { apiData, translation } = requestObj;
  const lang = translation !== 'en' ? `/${translation}` : '';
  const RailData = apiData.slice(1);
  let itemListElement: DynamicObject[] = [];
  RailData.map((item: DynamicObject, index: number) => {
    const position = parseInt(index.toString(), 10) + 1;
    const name = item.original_title;
    const url = `https://www.zee5.com${lang}/collections/${item.original_title}/${item.id}`;
    const obj = {
      '@type': 'ListItem',
      position,
      name,
      url
    };
    itemListElement = [...itemListElement, obj];

    return item;
  });

  const schemaObj = {
    '@context': SCHEMA_SITE_URL,
    '@type': 'ItemList',
    itemListElement
  };
  return JSON.stringify(schemaObj);
}

/**
 * FAQ List Schema
 */
function faqListSchema(requestObj: DynamicObject) {
  const { apiData } = requestObj;
  let mainEntity: DynamicObject[] = [];
  if (apiData && apiData.length > 0) {
    apiData.map((item: DynamicObject) => {
      if (item && item.items && item.items.length > 0) {
        item.items.map((row: DynamicObject) => {
          const obj = {
            '@type': 'Question',
            name: row.que,
            acceptedAnswer: {
              '@type': 'Answer',
              text: row.ans
            }
          };
          mainEntity = [...mainEntity, obj];
          return row;
        });
      }
      return item;
    });
  }
  const schemaObj = {
    '@context': SCHEMA_SITE_URL,
    '@type': 'FAQPage',
    mainEntity
  };
  return JSON.stringify(schemaObj);
}

export const storiesItemListSchema = () => {
  const storiesObj = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        url: 'https://zeekannada.zee5.com/news',
        name: 'Zee Kannada News'
      },
      {
        '@type': 'ListItem',
        position: 2,
        url: 'https://zeebangla.zee5.com',
        name: 'Zee Bangla'
      },
      {
        '@type': 'ListItem',
        position: 3,
        url: 'https://zeetv.zee5.com',
        name: 'Zee TV'
      },
      {
        '@type': 'ListItem',
        position: 4,
        url: 'https://andtv.zee5.com',
        name: '& TV'
      },
      {
        '@type': 'ListItem',
        position: 5,
        url: 'https://zeekeralam.zee5.com',
        name: 'Zee Keralam'
      },
      {
        '@type': 'ListItem',
        position: 6,
        url: 'https://zeemarathi.zee5.com',
        name: 'Zee Marathi'
      },
      {
        '@type': 'ListItem',
        position: 7,
        url: 'https://zeeyuva.zee5.com',
        name: 'Zee Yuva'
      },
      {
        '@type': 'ListItem',
        position: 8,
        url: 'https://zeepunjabi.zee5.com',
        name: 'Zee Punjabi'
      },
      {
        '@type': 'ListItem',
        position: 9,
        url: 'https://zeetamil.zee5.com',
        name: 'Zee Tamil'
      },
      {
        '@type': 'ListItem',
        position: 10,
        url: 'https://zeetelugu.zee5.com',
        name: 'Zee Telugu'
      }
    ]
  };
  return JSON.stringify(storiesObj);
};

const namesIN: string[] = [];
const name = [];
const url: string[] = [];
let scheme: DynamicObject = {};
let schemeIN: DynamicObject[] = [];

const getSiteNavigation = (name: string[] = [], url: string[] = []) => {
  name = [
    ...name,
    'ZEE5',
    'TV Shows',
    'Movies',
    'Premium',
    'News',
    'Kids',
    'Music Videos',
    'Play5',
    'Live TV',
    'ZEE5 Original Web Series',
    'ZEE Plex',
    'ZEE5 News',
    'Entertainment',
    'HiPi',
    'Web Stories',
    'Videos'
  ];

  url = [
    ...url,
    `${BASE_URL}`,
    `${BASE_URL}/tv-shows`,
    `${BASE_URL}/movies`,
    `${BASE_URL}/premium`,
    `${BASE_URL}/news`,
    `${BASE_URL}/kids`,
    `${BASE_URL}/music-videos`,
    `${BASE_URL}/play5-games`,
    `${BASE_URL}/livetv`,
    `${BASE_URL}/web-series`,
    `${BASE_URL}/zee-plex-movies-on-rent`,
    `${BASE_URL}/zee5news`,
    `${BASE_URL}/zee5news/entertainment`,
    `${BASE_URL}/hipionzee5`,
    `${BASE_URL}/articles`,
    `${BASE_URL}/videos`
  ];
  return { name, url };
};

const getSiteNavigationIN = (requestObj: DynamicObject) => {
  namesIN.push(
    'Home',
    'TV Shows',
    'Movies',
    'Web Series',
    'News',
    'Eduauraa',
    'Premium',
    'LIVE TV',
    'Music',
    'Rent',
    'Play',
    'Articles',
    'Kids',
    'Videos',
    'Zee5News',
    'TV Channels'
  );
  url.push(
    `${BASE_URL}`,
    `${BASE_URL}/tv-shows`,
    `${BASE_URL}/movies`,
    `${BASE_URL}/web-series`,
    `${BASE_URL}/news`,
    `${BASE_URL}/eduauraa`,
    `${BASE_URL}/premium`,
    `${BASE_URL}/livetv`,
    `${BASE_URL}/music-videos`,
    `${BASE_URL}/zee-plex-movies-on-rent`,
    `${BASE_URL}/play5-games`,
    `${BASE_URL}/articles`,
    `${BASE_URL}/kids`,
    `${BASE_URL}/videos`,
    `${BASE_URL}/zee5news`,
    `${BASE_URL}/tv-channels`
  );
  let schemaObject;
  const { location: currentPath = '' } = requestObj || {};
  const currentPageUrl = currentPath ? `${BASE_URL}${currentPath}` : '';
  namesIN.forEach((nameIN, index) => {
    schemaObject = {
      '@context': SCHEMA_SITE_URL,
      '@type': 'SiteNavigationElement',
      '@id': `${currentPageUrl}#table-of-contents`,
      name: nameIN,
      url: url[index]
    };
    schemeIN.push(schemaObject);
  });
  return schemeIN;
};

const siteNavigationElementSchema = (requestObj: DynamicObject) => {
  let schemaObj;
  const { countryCode } = requestObj;
  if (!namesIN.length && !url.length && countryCode === CountryCode.IN) {
    schemeIN = getSiteNavigationIN(requestObj);
  } else if (!name.length && !url.length && countryCode !== CountryCode.IN) {
    scheme = getSiteNavigation();
  }
  if (countryCode === CountryCode.IN) {
    schemaObj = {
      '@context': SCHEMA_SITE_URL,
      '@graph': schemeIN
    };
  } else {
    schemaObj = {
      '@context': SCHEMA_SITE_URL,
      '@type': 'SiteNavigationElement',
      name: scheme.name,
      url: scheme.url
    };
  }
  return JSON.stringify(schemaObj);
};

function createMediaSchema(requestObj: DynamicObject) {
  const { apiData = {}, pageMeta = {} } = requestObj;
  if (!name.length && !url.length) {
    scheme = getSiteNavigation();
  }
  const schemaObj = {
    '@context': SCHEMA_SITE_URL,
    '@type': 'MediaSubscription',
    name: pageMeta.title,
    description: pageMeta.description,
    image: SCHEMA_IMAGE,
    url: `${BASE_URL}/offers/combo-offer`,
    authenticator: {
      '@type': 'Organization',
      name: 'ZEE5'
    },
    expectsAcceptanceOf: {
      '@type': 'Offer',
      price: apiData.actualPrice || '499',
      priceCurrency: apiData.actualCurrency || 'INR'
    }
  };
  return JSON.stringify(schemaObj);
}

const getFAQSchemaObject = (ogUrl: string) => {
  let faqConstant;

  if (ogUrl.includes(WRITER_PADMABUSHAN_CONTENT_ID)) {
    faqConstant = writerPadmabushanFAQschema;
  } else if (ogUrl.includes(WANTED_CONTENT_ID)) {
    faqConstant = wantedFAQschema;
  } else if (ogUrl.includes(SIRF_EK_BANDAA_KAAFI_HAI_CONTENT_ID)) {
    faqConstant = SirfEkBandaaKaafiHaiFAQschema;
  } else if (ogUrl.includes(RRR_CONTENT_ID)) {
    faqConstant = rrrFAQschema;
  } else if (ogUrl.includes(gadar2MovieID)) {
    faqConstant = Gadar2FAQschema;
  } else if (ogUrl.includes(ghoomerMovieId)) {
    faqConstant = GhoomerFAQschema;
  } else if (ogUrl.includes(kadakSinghMovieId)) {
    faqConstant = KadakSinghFAQschema;
  } else if (ogUrl.includes(tejasMovieId)) {
    faqConstant = tejasMovieFAQschema;
  } else if (ogUrl.includes(samBahadurMovieId)) {
    faqConstant = samBahadurMovieFAQschema;
  } else if (ogUrl.includes(Khichdi2MovieId)) {
    faqConstant = Khichdi2MovieFAQschema;
  } else if (ogUrl.includes(theKeralaStoryMovieId)) {
    faqConstant = theKeralaStoryFAQschema;
  } else if (ogUrl.includes(mainAtalHoonMovieId)) {
    faqConstant = mainAtalHoonFAQschema;
  } else if (ogUrl.includes(hanuManMovieId)) {
    faqConstant = hanuManMovieFAQschema;
  } else if (ogUrl.includes(KISI_KA_BHAI_KISI_KI_JAAN_CONTENT_ID)) {
    faqConstant = KisiKaBhaiKisikiJaanFAQschema;
  } else {
    faqConstant = VenkateshDaggubattiFAQschema;
  }
  return faqConstant;
};
function QnASchema(requestObj: DynamicObject) {
  let faqConstant: FAQSchemaType[] = [];
  if (requestObj && requestObj.ogUrl) {
    faqConstant = getFAQSchemaObject(requestObj.ogUrl);
  }
  const questionAnswerObj: DynamicObject[] = [];
  faqConstant.forEach(({ question, answer }) => {
    const faqObj = {
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer
      }
    };
    questionAnswerObj.push(faqObj);
  });
  const schemaObj = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [...questionAnswerObj]
  };
  return JSON.stringify(schemaObj);
}
